import { Outlet, Navigate } from "react-router-dom";

const AnonymousRoutes = ({ isAuthenticated }) => {
  return !isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default AnonymousRoutes;
